import { useMemo } from 'react';

import { AllVestaAssets, FarmTypes } from '~config/types';

import { DeterminedQueryResult, IndexedQueriesParams, IndexedQueriesReturn } from './_types';

export function useIndexedQueries<
  IndexType extends AllVestaAssets | FarmTypes,
  ReturnType,
  ComputedType = any,
>(
  params: IndexedQueriesParams<IndexType, ReturnType, ComputedType>,
): IndexedQueriesReturn<IndexType, ReturnType, ComputedType> {
  const dataArr = params.indexValues.map(
    asset =>
      // not as evil as one would think 😈
      // Since our calls to our hooks are always called in the same order, we can permit this.
      // !!Don't do this if you cant guarantee hook call order!!
      // eslint-disable-next-line react-hooks/rules-of-hooks
      ({ data: params.hook(asset), asset: asset } as {
        data: DeterminedQueryResult<ReturnType>;
        asset: IndexType;
      }),
  );

  const responses = dataArr.reduce((prev, cur) => {
    return { ...prev, [cur.asset]: cur.data };
  }, {} as { [index in IndexType]: DeterminedQueryResult<ReturnType> });

  const computed = useMemo(() => (params.onArray ? params.onArray(dataArr) : undefined), [dataArr, params]);

  return {
    responses,
    computed,
  } as any;
  // do not remove this any, it helps determine whether the response has computed or not computed in IndexedQueriesReturn
}
